import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Footer.css';


const Footer = () => {
  const location = useLocation();
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const [isLogosVisible, setIsLogosVisible] = useState(false);

  useEffect(() => {
    const footerTimer = setTimeout(() => {
      setIsFooterVisible(true);
    }, 5500); 

    const logosTimer = setTimeout(() => {
      setIsLogosVisible(true);
    }, 6500); 

    return () => {
      clearTimeout(footerTimer);
      clearTimeout(logosTimer);
    }; 
  }, []);

  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname.startsWith('/subscriptores') || 
                       location.pathname.startsWith('/editor-masivo') || location.pathname.startsWith('/historial-ventas') || 
                       location.pathname.startsWith('/reporte-de-ventas') || location.pathname.startsWith('/local') || 
                       location.pathname.startsWith('/configuracion-descuentos')  || location.pathname.startsWith('/gestion-stock') ;

  return (
    <footer className={`footer ${isFooterVisible ? 'visible' : 'hidden'}`}>
      {isAdminRoute ? (
        <h1>PRIVISTORE</h1>
      ) : (
        <>
          <div className={`footer-logos-container ${isLogosVisible ? 'visible' : 'hidden'}`}>
          
          </div>
          <div className="footer-contact">
            <h4>El Macho bebidas</h4>
            <p>Presidente Perón 130</p>
            <p>Bell Ville, Córdoba, Argentina.</p>
            <p>Teléfono: +54 9 3537 536649</p>
          </div>
          <div className="footer-developer">
            {/* <p>Desarrollado por: Mariano Privitera</p>
            <p>priviteramariano@gmail.com</p> */}
          </div>
        </>
      )}
    </footer>
  );
};

export default Footer;
